import React, {useState} from 'react';
import Star from '../item/Star';

const SetRating = (props) => {

    const {score, setScore} = props;
    
    let stars = [];
    for (let i=1; i<=5; i++) {
        stars.push(
            <Star order={i} key={i} isEditable={true} score={score} setScore={setScore} />
        )
    }

    return (
        <div>
            {stars}
        </div>
    );
}

export default SetRating;